/*
  Wholesome Story theme JS (theme core)
  LAST UPDATED: 2026-10-07 PST
  Small progressive enhancements only. The site works with JavaScript off.
  1. Marks the current page link in the header menu (aria-current) for the pill style.
  2. Lets the "shop by need" pill row on the home page scroll with the keyboard.
*/
(function () {
  'use strict';

  function markCurrentLinks() {
    var path = window.location.pathname.replace(/\/$/, '');
    document.querySelectorAll('.header__inline-menu a[href], .menu-drawer a[href]').forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;
      var linkPath;
      try {
        linkPath = new URL(href, window.location.origin).pathname.replace(/\/$/, '');
      } catch (e) {
        return;
      }
      if (linkPath && linkPath === path) link.setAttribute('aria-current', 'page');
    });
  }

  function enableScrollerKeys() {
    document.querySelectorAll('.ws-scroller').forEach(function (scroller) {
      scroller.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') scroller.scrollBy({ left: 160, behavior: 'smooth' });
        if (event.key === 'ArrowLeft') scroller.scrollBy({ left: -160, behavior: 'smooth' });
      });
    });
  }

  function init() {
    markCurrentLinks();
    enableScrollerKeys();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
